module.exports = __webpack_public_path__ + "img/sad.0629a541.svg";